var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 21.3333H106.667V85.3333H27.5732L21.3332 91.5733V21.3333ZM21.3332 10.6667C15.4665 10.6667 10.7198 15.4667 10.7198 21.3333L10.6665 117.333L31.9998 96H106.667C112.533 96 117.333 91.2 117.333 85.3333V21.3333C117.333 15.4667 112.533 10.6667 106.667 10.6667H21.3332ZM31.9998 64H74.6665V74.6667H31.9998V64ZM31.9998 48H95.9998V58.6667H31.9998V48ZM31.9998 32H95.9998V42.6667H31.9998V32Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.9e3833fcea2f909471ac9fc5dda52325.svg";
export { ForwardRef as ReactComponent };